import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpService} from './http.service';
import {AuthService} from './auth.service';
import {CommandEnvelope} from '../generate/CommandEnvelope';

@Injectable({
  providedIn: 'root'
})
export class CommonRzmService extends HttpService {

  constructor(@Inject(HttpClient) http: HttpClient, @Inject('env') private environment, @Inject(AuthService) auth: AuthService) {
    super(http, auth);
  }

  createCommandEnvelope(command, type: string): CommandEnvelope {
    const commandEnvelope: CommandEnvelope = {};
    commandEnvelope.payload = command;
    commandEnvelope.commandType = type;

    return commandEnvelope;
  }

  getRestEndPoint(): string {
    if (this.environment.config == null || this.environment.config.staffBackendUrl == null) {
      return '';
    } else {
      return `${this.environment.config.staffBackendUrl}`;
    }
  }
}
